// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3yCFD","content":"GlobalSearch_content__QnVdj"};